import { appRoutes } from 'constants/appRoutes';
import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Form, Row } from 'react-bootstrap'
import { ArrowLeft, ArrowLeftCircle, PersonFill, X } from 'react-bootstrap-icons';
import { useNavigate, useParams } from 'react-router-dom';
import apiService from 'services/apiService';

const UserDetails = () => {
    const { id } = useParams();
    const [user, setUser] = useState();
    const navigate = useNavigate({});

    useEffect(() => {
        if (id) {
            apiService.get(`user/${id}`).then((res) => setUser(res));
        }
    }, []);

    return (
        <Row className="justify-content-center">
            <Col md={6}>
                <Card className='card-default'>
                    <Card.Header>
                        <PersonFill /> User Details
                    </Card.Header>
                    <Card.Body>
                        <Form>
                            <Form.Group as={Row} className="mb-2">
                                <Form.Label column sm={3}>First Name:</Form.Label>
                                <Col sm={9}>
                                    <Form.Label column>{user && user.firstName}</Form.Label>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-2">
                                <Form.Label column sm={3}>Last Name:</Form.Label>
                                <Col sm={9}>
                                    <Form.Label column>{user && user.lastName}</Form.Label>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-2">
                                <Form.Label column sm={3}>Username:</Form.Label>
                                <Col sm={9}>
                                    <Form.Label column>{user && user.username}</Form.Label>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-2">
                                <Form.Label column sm={3}>Email:</Form.Label>
                                <Col sm={9}>
                                    <Form.Label column>{user && user.email}</Form.Label>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-2">
                                <Form.Label column sm={3}>Mobile No:</Form.Label>
                                <Col sm={9}>
                                    <Form.Label column>{user && user.mobileNo}</Form.Label>
                                </Col>
                            </Form.Group>
                        </Form>
                    </Card.Body>
                    <Card.Footer className='text-center'>
                        <Button
                            type="button"
                            variant='secondary'
                            className='ms-3 mw-100'
                            onClick={() => navigate(appRoutes.users)}
                            size='sm'>
                            <ArrowLeftCircle size={16} /> Back
                        </Button>
                    </Card.Footer>
                </Card>
            </Col>
        </Row>
    )
}

export default UserDetails